import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import ImageUploaderDropZone from "../../../../common/image-uploader/dropzone.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'
import CustomFieldsSelectComponent from '../../../../scheduling-page/CustomFieldsSelectComponent'
import {CUSTOM_FIELD_TYPE, getCustomFieldAvailableFromOptionsByProposalType} from "../../../../utils/customField"
class ImageGalleryContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            images: content.images || [],
            imageIds: this.props.imageIds || content.imageIds || [],
            hideLabels: this.props.hideLabels || false,
            disabled: this.props.disabled || false,
            accountId: this.props.accountId || '',
            imagesPerRow: this.props.imagesPerRow || content.imagesPerRow || '4',
            hideImagesPerRow: this.props.hideImagesPerRow || false,
            customFieldDefinitionIds: content.customFieldDefinitionIds || [],
            variables: this.props.variables || {},
        }
        this.handleImageChange = this.handleImageChange.bind(this)
        this.handleImagesPerRowChange = this.handleImagesPerRowChange.bind(this)
        this.child = React.createRef();
    }

    triggerChanged() {
        this.state.onChange({
            imageIds: this.state.imageIds,
            customFieldDefinitionIds: this.state.customFieldDefinitionIds,
            imagesPerRow: this.state.imagesPerRow,
        })
    }

    componentDidMount() {
        if (this.props.loadedImages) {
            this.setState({
                images: this.props.loadedImages,
            }, () => { this.child.current.updateUploadedImagesFromImages(this.state.images) })
        } else if (this.props.imageIds && this.props.imageIds.length > 0) {
            Promise.all(this.props.imageIds.map(imageId => AppContext.getApiClient().get('/images/' + imageId)))
                .then((images) => {
                    this.setState({
                        images,
                    }, () => { this.child.current.updateUploadedImagesFromImages(this.state.images) })
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            images: content.images || this.props.loadedImages || [],
            imageIds: content.imageIds || this.props.imageIds || [],
            imagesPerRow: content.imagesPerRow || nextProps.imagesPerRow || '4'
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                imageIds: images.map(i => i.id),
            }, this.triggerChanged)
        } else {
            this.setState({
                images: [],
                imageIds: [],
            }, this.triggerChanged)
        }
    }

    handleImagesPerRowChange(event) {
        let {value, min, max} = event.target;
        if(Number(value) >= Number(min) && Number(value) <= Number(max)) {
            this.setState({
                imagesPerRow: value
            }, this.triggerChanged)
        } else {
            value = Math.max(Number(min), Math.min(Number(max), Number(value)))
        }
    }

    render() {

        return (
            <div>
                <div className="form-group row">
                    {!this.state.hideLabels &&
                        <label className="col-2 col-form-label text-align-right" htmlFor="title">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image_gallery.images_label"
                                defaultMessage="Images"
                            />
                        </label>
                    }
                    <div className={!this.state.hideLabels ? 'col-10' : 'col-12'} style={{
                        pointerEvents: this.state.disabled ? 'none' : '',
                    }}>
                        <ImageUploaderDropZone
                            ref={this.child}
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={10}
                            images={this.state.images}
                            accountId={this.state.accountId}
                            alreadyAdded={false}
                        />
                        {!this.state.hideLabels &&
                            < small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.image_gallery.images_description"
                                    defaultMessage="Images that will be available in the gallery"
                                />
                            </small>
                        }
                    </div>
                </div>

                {!this.state.hideImagesPerRow &&
                    <div className="form-group row">
                        {!this.state.hideLabels &&
                            <label className="col-2 col-form-label text-align-right" htmlFor="imagesPerRow">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.image_gallery.images_per_row_label"
                                    defaultMessage="Images per Row"
                                />
                            </label>
                        }
                        <div className={!this.state.hideLabels ? 'col-10' : 'col-12'} style={{
                            pointerEvents: this.state.disabled ? 'none' : '',
                        }}>
                            <div className="input-group">
                                <input
                                    name="imagesPerRow"
                                    value={this.state.imagesPerRow}
                                    onChange={this.handleImagesPerRowChange}
                                    id="imagesPerRow"
                                    type="number"
                                    className="form-control"
                                    min={1}
                                    max={5}
                                />
                            </div>
                            {!this.state.hideLabels &&
                                < small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.image_gallery.images_per_row_description"
                                        defaultMessage="The number of images that will be displayed per row"
                                    />
                                </small>
                            }
                        </div>
                    </div>
                }

                {!this.state.hideLabels &&
                    <div className="form-group row">
                        <label className="col-2 col-form-label text-align-right" htmlFor="title">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.image_gallery.custom_fields_label"
                                defaultMessage="Custom fields (optional)"
                            />
                        </label>

                        <div className={'col-10'} style={{
                            pointerEvents: this.state.disabled ? 'none' : '',
                        }}>
                            <CustomFieldsSelectComponent
                                editable={true}
                                name={'image-gallery-custom-fields'}
                                selectedCustomFieldIds={this.state.customFieldDefinitionIds}
                                onSelectChange={(selectedOptions) => {
                                    this.setState(
                                        { customFieldDefinitionIds: selectedOptions.map(o => o.value) },
                                        this.triggerChanged
                                    )
                                }}
                                isAvailableFrom={getCustomFieldAvailableFromOptionsByProposalType(this.state.variables?.proposalType)}
                                supportedFieldTypes={[CUSTOM_FIELD_TYPE.IMAGE]}
                                placeholder={<FormattedMessage
                                    id="templates.sections.form.edit.content.image_gallery.custom_fields_placeholder"
                                    defaultMessage="Choose one or more custom fields"
                                />}
                            />
                            < small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.image_gallery.custom_fields_description"
                                    defaultMessage="Include images that are linked to the chosen custom fields"
                                />
                            </small>
                        </div>
                    </div>
                }

            </div >
        );
    }
}

export default injectIntl(ImageGalleryContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/image-gallery/input.component.jsx